import React from 'react'
import PropTypes from 'prop-types'
import NavBar from './NavBar'
import tabsPropType from '../propTypes/tabs.shape'

import styles from './TertiaryNav.css'

const TertiaryNav = ({ tabs }) => (
  <header className={styles.header}>
    <div className={styles.main}>
      <NavBar showIcons={false} tabs={tabs} />
    </div>
  </header>
)

TertiaryNav.propTypes = {
  tabs: tabsPropType
}

export default TertiaryNav
